import {ProductsParamsType} from "@/lib/products";

export const getQueryString = (params: Record<string, any>) => {
    const ORDER = [
        "Page",
        "SortOrder",
        "SearchText",
        "isExists",
        "Car",
        "Company",
        "Section",
        "OnlyNewests",
        "OnlyOffers",
        "OnlyWithPicture"
    ];

    const cleaned: Record<string, any> = {};

    for (const key of ORDER) {
        const value = params[key];

        if (value === undefined || value === null) continue;
        if (Array.isArray(value) && value?.length === 0) continue;
        if (typeof value === "string" && value.trim() === "") continue;

        cleaned[key] = value;
    }

    return Object.entries(cleaned)
        .flatMap(([key, value]) =>
            Array.isArray(value)
                ? value.map((v) => `${key}=${encodeURIComponent(v)}`)
                : `${key}=${encodeURIComponent(value)}`
        )
        .join("&");
};

export const cleanEmptyQueryValues = (
    queries: Record<string, string | string[] | undefined>
) => {
    const cleaned: Record<string, any> = {};
    Object.entries(queries).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            const filtered = value.filter(
                (v) => typeof v === "string" && v.trim() !== ""
            );
            if (filtered?.length > 0) cleaned[key] = filtered;
        } else if (typeof value === "string" && value.trim() !== "") {
            cleaned[key] = value.trim();
        }
    });
    return cleaned;
};


export const createParamsFromQueries = (queries: Record<string, any>) => {
    const format = (value: string | string[] | undefined): number[] => {
        if (!value) return [];
        if (Array.isArray(value)) return value.map(Number);
        return value.split(",").map(Number);
    };

    const params: ProductsParamsType = {
        ...queries,

        SearchText: queries.SearchText ?? "",

        Car: format(queries.Car),
        Company: format(queries.Company),
        Section: format(queries.Section),

        isExists:
            typeof queries.isExists === "string"
                ? queries.isExists === "true"
                : undefined,

        OnlyNewests:
            queries.OnlyNewests === "true"
                ? true
                : undefined,

        OnlyOffers:
            queries.OnlyOffers === "true"
                ? true
                : undefined,

        OnlyWithPicture:
            queries.OnlyWithPicture === "true"
                ? true
                : undefined,

        Page: queries.Page ? Number(queries.Page) : 1,
    };

    return params;
};

export const createQueriesFromSearchParams = (
    searchParams: Pick<URLSearchParams, "forEach">
) => {
    const queries: Record<string, string | string[]> = {};

    searchParams.forEach((value, key) => {
        const current = queries[key];

        if (current === undefined) {
            queries[key] = value;
        } else if (Array.isArray(current)) {
            current.push(value);
        } else {
            queries[key] = [current, value];
        }
    });

    return queries;
};

export const changeUrl = (query: Record<string, any>) => {
    if (typeof window === "undefined") return;
    const qs = getQueryString(query);
    const newUrl = qs ? `/products?${qs}` : `/products`;

    window.history.pushState(
        {...window.history.state, as: newUrl, url: newUrl},
        "",
        newUrl
    );
};

